import { render, staticRenderFns } from "./AssignAnnotation.vue?vue&type=template&id=613f5748&scoped=true&"
import script from "./AssignAnnotation.vue?vue&type=script&lang=js&"
export * from "./AssignAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./AssignAnnotation.vue?vue&type=style&index=0&id=613f5748&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613f5748",
  null
  
)

export default component.exports